<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <footer class="text-muted monaco">
          Copyright &copy; 2019 - {{ now }}. All rights reserved.
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        now: new Date().getFullYear()
      }
    }
  }
</script>

<style scoped>
footer {
  font-size: 13px;
  margin: 100px 0;
}
</style>
